import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_custom-systems-3/artifacts/9l7q7y3q_Aakuant%20Ai.PNG";

const LAST_UPDATED = "22 de setembro de 2026";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-outfit font-semibold text-xl sm:text-2xl text-white mb-4">
      {title}
    </h2>
    <div className="font-manrope text-white/65 text-[15px] leading-relaxed space-y-3">
      {children}
    </div>
  </section>
);

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="privacy-policy-page">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-6 h-[76px]">
          <Link
            to="/"
            className="flex items-center gap-2.5 group"
            data-testid="privacy-logo-link"
          >
            <img
              src={LOGO_URL}
              alt="Akuant Solutions"
              className="h-8 w-8 object-contain"
            />
            <span className="font-outfit font-semibold text-base sm:text-lg text-white tracking-tight">
              Akuant<span className="text-[#00D2D3]">.</span>
            </span>
          </Link>
          <Link
            to="/"
            className="text-sm text-white/60 hover:text-[#00D2D3] transition-colors font-manrope"
            data-testid="privacy-back-link"
          >
            ← Voltar ao site
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="font-mono-accent text-xs text-[#00D2D3] uppercase tracking-widest mb-4">
          LGPD · Lei nº 13.709/2018
        </p>
        <h1 className="font-outfit font-bold text-3xl sm:text-4xl text-white mb-3">
          Política de Privacidade
        </h1>
        <p className="font-manrope text-white/45 text-sm mb-14">
          Última atualização: {LAST_UPDATED}
        </p>

        <Section title="1. Quem somos">
          <p>
            Esta Política de Privacidade se aplica ao site akuantsolutions.com e aos
            demais canais de contato da <strong className="text-white/85">Akuant Solutions</strong>{" "}
            ("Akuant", "nós"), empresa de desenvolvimento de sistemas sob
            medida, landing pages e automação de processos.
          </p>
          <p>
            Para qualquer dúvida sobre esta política ou sobre o tratamento dos
            seus dados pessoais, entre em contato pelo e-mail{" "}
            <a
              href="mailto:contato@akuant.com"
              className="text-[#00D2D3] hover:underline"
            >
              contato@akuant.com
            </a>
            .
          </p>
        </Section>

        <Section title="2. Quais dados coletamos">
          <p>Coletamos dados pessoais nas seguintes situações:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong className="text-white/85">Formulário de contato do site:</strong>{" "}
              nome, e-mail ou número de WhatsApp e a mensagem descrevendo o
              projeto, fornecidos voluntariamente por você.
            </li>
            <li>
              <strong className="text-white/85">Contato direto:</strong> dados
              trocados quando você fala com a gente por e-mail ou redes
              sociais.
            </li>
            <li>
              <strong className="text-white/85">Dados de navegação:</strong>{" "}
              informações coletadas automaticamente por cookies e ferramentas
              de análise (endereço IP aproximado, tipo de dispositivo,
              navegador, páginas visitadas e tempo de permanência), incluindo
              gravações de sessão anonimizadas para entender como o site é
              usado.
            </li>
            <li>
              <strong className="text-white/85">Dados de campanhas de anúncios:</strong>{" "}
              quando você chega até nós por um anúncio (ex: LinkedIn, Google,
              Meta), essas plataformas podem registrar cookies próprios para
              medir a conversão. Essa coleta é feita pela plataforma de
              anúncio, sob a política de privacidade dela.
            </li>
          </ul>
          <p>Não coletamos dados sensíveis (saúde, biometria, origem racial, religião, etc.) nem dados de crianças e adolescentes.</p>
        </Section>

        <Section title="3. Para que usamos seus dados">
          <ul className="list-disc pl-5 space-y-2">
            <li>Responder à sua solicitação de orçamento ou contato comercial;</li>
            <li>Entender o escopo do seu projeto antes de uma proposta;</li>
            <li>Enviar comunicações sobre o andamento de um projeto em curso;</li>
            <li>Melhorar o conteúdo, a performance e a usabilidade do site;</li>
            <li>Medir a efetividade de campanhas de anúncios (dados agregados, sem identificação individual para nós);</li>
            <li>Cumprir obrigações legais ou regulatórias, quando aplicável.</li>
          </ul>
          <p>Não vendemos seus dados pessoais e não os utilizamos para fins diferentes dos descritos aqui sem o seu consentimento.</p>
        </Section>

        <Section title="4. Base legal (Art. 7º da LGPD)">
          <p>
            O tratamento dos seus dados é baseado no{" "}
            <strong className="text-white/85">consentimento</strong> (quando
            você preenche o formulário ou envia mensagem) e no{" "}
            <strong className="text-white/85">legítimo interesse</strong> da
            Akuant em responder solicitações comerciais e melhorar seus
            serviços, sempre respeitando seus direitos e expectativas.
          </p>
        </Section>

        <Section title="5. Com quem compartilhamos">
          <p>Seus dados podem ser processados pelos seguintes prestadores de serviço, que atuam como operadores em nosso nome:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Infraestrutura de banco de dados e hospedagem (ex: MongoDB Atlas, Render, Hostinger);</li>
            <li>Ferramentas de analytics e monitoramento de sessão (ex: PostHog);</li>
          </ul>
          <p>
            Não compartilhamos seus dados pessoais com terceiros para fins de
            marketing de terceiros, nem os vendemos ou alugamos.
          </p>
        </Section>

        <Section title="6. Cookies">
          <p>
            Utilizamos cookies e tecnologias similares para lembrar suas
            preferências, entender como o site é utilizado e medir a
            performance de campanhas de anúncio. Você pode desativar cookies
            nas configurações do seu navegador, embora isso possa afetar
            algumas funcionalidades do site.
          </p>
        </Section>

        <Section title="7. Por quanto tempo guardamos seus dados">
          <p>
            Mantemos seus dados pelo tempo necessário para cumprir a
            finalidade para a qual foram coletados: em geral, enquanto
            durar o relacionamento comercial ou até 24 meses após o último
            contato (o que for mais longo), ou até que você solicite a
            exclusão, respeitadas obrigações legais de retenção quando
            aplicáveis.
          </p>
        </Section>

        <Section title="8. Seus direitos (Art. 18 da LGPD)">
          <p>Você pode, a qualquer momento e gratuitamente, solicitar:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Confirmação da existência de tratamento dos seus dados;</li>
            <li>Acesso aos dados que temos sobre você;</li>
            <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
            <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade com a lei;</li>
            <li>Portabilidade dos dados a outro fornecedor de serviço;</li>
            <li>Eliminação dos dados tratados com base no seu consentimento;</li>
            <li>Revogação do consentimento a qualquer momento;</li>
            <li>Informação sobre com quem compartilhamos seus dados.</li>
          </ul>
          <p>
            Para exercer qualquer um desses direitos, escreva para{" "}
            <a
              href="mailto:contato@akuant.com"
              className="text-[#00D2D3] hover:underline"
            >
              contato@akuant.com
            </a>
            . Respondemos em até 15 dias.
          </p>
        </Section>

        <Section title="9. Segurança">
          <p>
            Adotamos medidas técnicas e organizacionais razoáveis para
            proteger seus dados contra acesso não autorizado, perda,
            alteração ou divulgação indevida, incluindo conexões criptografadas
            (HTTPS/TLS) e controle de acesso restrito aos sistemas que
            armazenam seus dados.
          </p>
        </Section>

        <Section title="10. Alterações desta política">
          <p>
            Podemos atualizar esta Política de Privacidade periodicamente
            para refletir mudanças em nossas práticas ou na legislação. A
            data da última atualização estará sempre indicada no topo desta
            página.
          </p>
        </Section>

        <Section title="11. Contato">
          <p>
            Dúvidas, solicitações ou reclamações sobre o tratamento dos seus
            dados pessoais podem ser enviadas para{" "}
            <a
              href="mailto:contato@akuant.com"
              className="text-[#00D2D3] hover:underline"
            >
              contato@akuant.com
            </a>
            .
          </p>
        </Section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
